import { ELEVATION_SIZE } from "./elevation_consts"

export default function toElevation9GLSL (
  list: number[],
  base: number,
): number[] {
  const elevations = [...list, base]

  for (let i = 0; i < 9; i++) {
    elevations[i] *= ELEVATION_SIZE
  }

  return elevations
}